(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zenbodis-countdown"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.zb-countdown[data-hours]').forEach(function (root) {
  if (root.dataset.zbInit) return;
  root.dataset.zbInit = '1';
  var hours = parseInt(root.dataset.hours, 10) || 0;
  var minutes = parseInt(root.dataset.minutes, 10) || 0;
  var KEY = 'zb_offer_end';
  var end = parseInt(localStorage.getItem(KEY) || '0', 10);
  if (!end || end < Date.now()) {
    end = Date.now() + (hours * 3600 + minutes * 60) * 1000;
    localStorage.setItem(KEY, String(end));
  }
  var els = {
    d: root.querySelector('[data-zb-cd="d"]'),
    h: root.querySelector('[data-zb-cd="h"]'),
    m: root.querySelector('[data-zb-cd="m"]'),
    s: root.querySelector('[data-zb-cd="s"]')
  };
  if (!els.d) return;
  function pad(n) {
    return String(n).padStart(2, '0');
  }
  function tick() {
    var diff = Math.max(0, end - Date.now());
    var s = Math.floor(diff / 1000);
    els.d.textContent = pad(Math.floor(s / 86400));
    els.h.textContent = pad(Math.floor((s % 86400) / 3600));
    els.m.textContent = pad(Math.floor((s % 3600) / 60));
    els.s.textContent = pad(s % 60);
  }
  tick();
  setInterval(tick, 1000);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zenbodis-product"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.zb-product[data-cart-add-url]').forEach(function (root) {
  if (root.dataset.zbInit) return;
  root.dataset.zbInit = '1';

  var variantsEl = root.querySelector('[data-zb-variants]');
  var variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
  var mainImage = root.querySelector('.zb-gallery__main img');
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-zb-thumb]'));
  var priceEl = root.querySelector('[data-zb-price]');
  var compareEl = root.querySelector('[data-zb-compare]');
  var variantField = root.querySelector('[data-zb-variant-id]');
  var qtyField = root.querySelector('[data-zb-qty-field]');
  var qtyInput = root.querySelector('[data-zb-qty-input]');
  var atcBtn = root.querySelector('[data-zb-atc]');
  var form = root.querySelector('[data-zb-form]');
  var toast = root.querySelector('[data-zb-toast]');
  var sticky = root.querySelector('[data-zb-sticky]');
  var stickyPrice = root.querySelector('[data-zb-sticky-price]');
  var stickyQty = root.querySelector('[data-zb-sticky-qty]');
  var stickyBtn = root.querySelector('[data-zb-sticky-atc]');
  var buybox = root.querySelector('[data-zb-buybox]');
  var qty = 1;

  thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      thumbs.forEach(function (x) {
        x.classList.remove('is-active');
      });
      t.classList.add('is-active');
      if (mainImage) {
        mainImage.removeAttribute('srcset');
        mainImage.src = t.getAttribute('data-full');
      }
    });
  });

  function currentOptions() {
    var opts = [];
    root.querySelectorAll('[data-zb-option-index]').forEach(function (group) {
      var checked = group.querySelector('input:checked');
      opts[parseInt(group.dataset.zbOptionIndex, 10)] = checked ? checked.value : null;
    });
    return opts;
  }

  function findVariant(opts) {
    return variants.find(function (v) {
      return v.options.every(function (o, i) {
        return o === opts[i];
      });
    });
  }

  function applyVariant(v) {
    if (!v) return;
    if (variantField) variantField.value = v.id;
    if (priceEl) priceEl.textContent = v.price;
    if (stickyPrice) stickyPrice.textContent = v.price;
    if (compareEl) {
      if (v.compare) {
        compareEl.textContent = v.compare;
        compareEl.hidden = false;
      } else {
        compareEl.textContent = '';
        compareEl.hidden = true;
      }
    }
    if (v.image && mainImage) {
      mainImage.removeAttribute('srcset');
      mainImage.src = v.image;
      thumbs.forEach(function (t) {
        t.classList.toggle('is-active', t.getAttribute('data-full') === v.image);
      });
    }
    if (atcBtn) {
      atcBtn.disabled = !v.available;
      atcBtn.textContent = v.available ? atcBtn.dataset.label : atcBtn.dataset.labelSoldout;
    }
  }

  root.querySelectorAll('[data-zb-option-index] input').forEach(function (input) {
    input.addEventListener('change', function () {
      applyVariant(findVariant(currentOptions()));
    });
  });

  function setQty(n) {
    qty = Math.min(10, Math.max(1, n));
    if (qtyInput) qtyInput.value = qty;
    if (qtyField) qtyField.value = qty;
    if (stickyQty) stickyQty.textContent = qty;
  }
  var minus = root.querySelector('[data-zb-qty-minus]');
  var plus = root.querySelector('[data-zb-qty-plus]');
  if (minus) minus.addEventListener('click', function () { setQty(qty - 1); });
  if (plus) plus.addEventListener('click', function () { setQty(qty + 1); });

  function feedback(btn) {
    var original = btn.dataset.label || btn.textContent;
    btn.classList.add('is-added');
    btn.textContent = btn.dataset.labelAdded || '✓';
    if (toast) toast.classList.add('is-show');
    setTimeout(function () {
      btn.classList.remove('is-added');
      btn.textContent = original;
      if (toast) toast.classList.remove('is-show');
    }, 1800);
  }

  // Lee la cantidad del campo real del formulario (name="quantity"). Apps de
  // packs como Kaching Bundles actualizan este input al elegir un pack, así que
  // hay que respetarlo en vez de la variable interna qty.
  function currentQty() {
    var n = qtyField ? parseInt(qtyField.value, 10) : qty;
    return !n || n < 1 ? qty : n;
  }

  // Recolecta las line item properties que apps de packs (Kaching Bundles)
  // inyectan en el formulario como <input name="properties[clave]">. Sin ellas
  // el descuento/deal del pack no se aplica al agregar al carrito.
  function collectProps() {
    var props = {};
    if (form) {
      form.querySelectorAll('[name^="properties["]').forEach(function (inp) {
        var m = inp.name.match(/^properties\[(.+)\]$/);
        if (m && inp.value !== '') props[m[1]] = inp.value;
      });
    }
    return props;
  }

  function addToCart(triggerBtn) {
    if (!variantField) return;
    var id = variantField.value;
    var quantity = currentQty();
    var props = collectProps();
    var hasProps = Object.keys(props).length > 0;
    var actions = window.Shopify && window.Shopify.actions;

    // API estándar del storefront: emite shopify:cart:lines-update y el tema
    // actualiza burbuja y drawer (con auto-open) por su cuenta.
    if (actions && typeof actions.updateCart === 'function') {
      var line = { merchandiseId: 'gid://shopify/ProductVariant/' + id, quantity: quantity };
      if (hasProps) {
        line.attributes = Object.keys(props).map(function (k) {
          return { key: k, value: props[k] };
        });
      }
      actions
        .updateCart({ lines: [line] }, { event: { context: 'product' } })
        .then(function (result) {
          if (result && result.userErrors && result.userErrors.length) {
            throw new Error(result.userErrors[0].message);
          }
          feedback(triggerBtn);
        })
        .catch(function () {
          window.location.href = root.dataset.cartAddUrl.replace('/add', '');
        });
      return;
    }

    fetch(root.dataset.cartAddUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: parseInt(id, 10), quantity: quantity, properties: props })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart-add-failed');
        return res.json();
      })
      .then(function () {
        feedback(triggerBtn);
        window.location.href = root.dataset.cartAddUrl.replace('/add', '');
      })
      .catch(function () {
        window.location.href = root.dataset.cartAddUrl.replace('/add', '');
      });
  }

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (atcBtn && !atcBtn.disabled) addToCart(atcBtn);
    });
  }
  if (stickyBtn) {
    stickyBtn.dataset.label = stickyBtn.textContent;
    stickyBtn.dataset.labelAdded = '✓ AGREGADO';
    stickyBtn.addEventListener('click', function () {
      if (atcBtn && atcBtn.disabled) return;
      addToCart(stickyBtn);
    });
  }

  if (sticky && buybox && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(
      function (entries) {
        sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
      },
      { threshold: 0 }
    );
    io.observe(buybox);
    var stickyInfo = root.querySelector('[data-zb-sticky-info]');
    if (stickyInfo) {
      stickyInfo.addEventListener('click', function () {
        window.scrollTo({
          top: buybox.getBoundingClientRect().top + window.pageYOffset - 80,
          behavior: 'smooth'
        });
      });
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zenbodis-review-carousel"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.zb-revcar').forEach(function (root) {
  if (root.dataset.zbInit) return;
  root.dataset.zbInit = '1';
  var track = root.querySelector('[data-zb-slider-track]');
  var dots = Array.prototype.slice.call(root.querySelectorAll('.zb-revcar__dot'));
  var i = 0;
  var n = dots.length;
  if (!track || n === 0) return;
  function go(k) {
    i = ((k % n) + n) % n;
    track.style.transform = 'translateX(-' + i * 100 + '%)';
    dots.forEach(function (d, j) {
      d.classList.toggle('is-active', j === i);
    });
  }
  dots.forEach(function (d) {
    d.addEventListener('click', function () {
      go(parseInt(d.dataset.i, 10));
    });
  });
  var prev = root.querySelector('[data-zb-prev]');
  var next = root.querySelector('[data-zb-next]');
  if (prev) prev.addEventListener('click', function () { go(i - 1); });
  if (next) next.addEventListener('click', function () { go(i + 1); });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zenbodis-social-videos"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.zb-social__play').forEach(function (btn) {
  if (btn.dataset.zbInit) return;
  btn.dataset.zbInit = '1';
  btn.addEventListener('click', function () {
    var video = btn.parentElement.querySelector('video');
    if (!video) return;
    if (video.paused) {
      video.muted = true;
      video.setAttribute('muted', '');
      video.play();
      btn.classList.add('is-hidden');
      video.addEventListener('click', function () {
        video.pause();
        btn.classList.remove('is-hidden');
      });
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
